import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaintenanceService, MaintenanceStatus } from 'src/app/core/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-maintenance-banner',
  templateUrl: './admin-maintenance-banner.component.html',
  styleUrls: ['./admin-maintenance-banner.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class AdminMaintenanceBannerComponent implements OnInit, OnDestroy {
  maintenanceStatus: MaintenanceStatus | null = null;
  showBanner: boolean = false;
  private statusSubscription?: Subscription;
  private bannerSubscription?: Subscription;

  constructor(private maintenanceService: MaintenanceService) {}

  ngOnInit() {
    this.statusSubscription = this.maintenanceService.maintenanceStatus$.subscribe(
      status => this.maintenanceStatus = status
    );
    
    this.bannerSubscription = this.maintenanceService.showAdminBanner$.subscribe(
      show => this.showBanner = show
    );
  }

  ngOnDestroy() {
    if (this.statusSubscription) {
      this.statusSubscription.unsubscribe();
    }
    if (this.bannerSubscription) {
      this.bannerSubscription.unsubscribe();
    }
  }

  get displayMessage(): string {
    return this.maintenanceStatus?.message || 'Wartung ist aktiv';
  }

  get updatedAt(): string | null {
    if (!this.maintenanceStatus?.updated_at) return null;
    return new Date(this.maintenanceStatus.updated_at).toLocaleString('de-AT');
  }

  closeBanner() {
    this.showBanner = false;
  }
}